import { useDispatch } from "react-redux"
import { actions } from "store"
import { alerts } from "keys"
import { reset } from "redux-form"

const useAlert = () => {
    const dispatch = useDispatch()

    return (val) => {
        dispatch(actions.setAlerts({
            key: alerts.createTestTakers,
            value: { open: val }
        }))
        if (!val)
            dispatch(reset("test_takers"))
    }
}

export default useAlert